













































import { Component, Vue, Watch } from "vue-property-decorator";
import { StorageKeys } from "@/main";
import { Routes } from "@/router";
import axios from "axios";

interface GitResponseModel {
  authenticated: boolean;
}

@Component
export default class App extends Vue {
  isAuthenticated: boolean | null = null;

  get isLoginPage(): boolean {
    return this.$route.path === Routes.Login;
  }

  @Watch("$route")
  onRouterChange(): void {
    this.validateUser();
  }

  mounted(): void {
    this.validateUser();
  }

  validateUser(): void {
    if (!this.isLoginPage) {
      if (Vue.IsProduction) {
        axios
          .post("api/verify.php", {
            authenticated: sessionStorage.getItem(StorageKeys.Authenticated) || localStorage.getItem(StorageKeys.Authenticated),
          })
          .then((response) => {
            if (!(response.data as GitResponseModel).authenticated) {
              this.$router.push("/login");
            } else {
              this.isAuthenticated = true;
            }
          });
      } else {
        if (!(sessionStorage.getItem(StorageKeys.Authenticated) || localStorage.getItem(StorageKeys.Authenticated))) {
          this.$router.push("/login");
        } else {
          this.isAuthenticated = true;
        }
      }
    }
  }

  logOut(): void {
    sessionStorage.removeItem(StorageKeys.Authenticated);
    localStorage.removeItem(StorageKeys.Authenticated);
    if (Vue.IsProduction) {
      axios.post("api/logout.php");
    }
    this.$router.push("/login");
  }
}
